// extracted by mini-css-extract-plugin
export default {"root":"y8gbzAttHm5Kv4XBja43","taskDescription":"j2taoeCiHDPFHwuCEyPy","placeHolderShimmer":"QmuIkvRW9c2vr78swBAb"};